import React, { useRef, useState } from 'react';
import { Modal, ModalProps } from 'antd';
import type { DraggableData, DraggableEvent } from 'react-draggable';
import Draggable from 'react-draggable';

const AntDraggableModal: React.FC<ModalProps> = ({
  children,
  classNames,
  maskClosable,
  mask,
  title,
  ...other
}) => {
  const draggleRef = useRef<HTMLDivElement>(null);
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
  const [disabled, setDisabled] = useState(true);

  const mergedMask = {
    ...(typeof mask === 'object' ? mask : {}),
    ...(maskClosable !== undefined ? { closable: maskClosable } : {}),
  };

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) return;

    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <Modal
      centered

      // mask={mergedMask}
      classNames={classNames}
      title={
        <div
          style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => { if (disabled) setDisabled(false); }}
          onMouseOut={() => { setDisabled(true); }}
          onFocus={() => {}}
          onBlur={() => {}}
        >
          {title}
        </div>
      }
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={bounds}
          onStart={onStart}
          nodeRef={draggleRef}
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      {...other}
    >
      {children}
    </Modal>
  );
};

export default AntDraggableModal;